export default __webpack_public_path__ + "static/media/aiCameraIcon.f9d447c9.svg";